import { app, Component, context, ojs } from "modular-openscriptjs";
import Container from "../Blocks/Container";
import Spinner from "../Blocks/Spinner";
import { inform } from "../../helpers";

const h = app("h");

ojs(Spinner, Container);

export default class ConfirmMpesaPayment extends Component {
    render() {
        const ctx = context("payment");

        return h.Container(
            { class: "py-5 mb-5" },
            
            h.h5(
                { class: "fw-bold mb-3 text-secondary" },
                "Awaiting Payment Completion"
            ),

            h.div(
                { class: "card border-0 shadow-sm rounded-4 mb-4 overflow-hidden" },
                
                h.div(
                    { class: "card-body p-4 text-center" },
                    
                    h.div(
                        { class: "py-4 d-flex flex-column align-items-center justify-content-center" },
                        h.div(
                            { class: "position-relative mb-4 d-flex align-items-center justify-content-center" },
                            h.Spinner()
                        ),
                        h.p(
                            { class: "text-muted mb-0 fw-500", style: "font-size: 0.95rem; max-width: 320px; margin: 0 auto;" },
                            "Please enter your M-Pesa PIN on your phone's popup prompt to authorize this payment."
                        )
                    ),
                    
                    h.hr({ class: "my-3 opacity-25" }),

                    h.div(
                        { class: "row g-3 text-start mt-2" },
                        h.div(
                            { class: "col-6 border-end" },
                            h.small({ class: "text-muted text-uppercase fw-bold d-block mb-1", style: "font-size: 0.7rem; letter-spacing: 0.5px;" }, "Total Amount"),
                            h.h4({ class: "text-success fw-bold mb-0" }, `${ctx?.mpesaInfo?.amount || "0.00"}`)
                        ),
                        h.div(
                            { class: "col-6 ps-4" },
                            h.small({ class: "text-muted text-uppercase fw-bold d-block mb-1", style: "font-size: 0.7rem; letter-spacing: 0.5px;" }, "Charges"),
                            h.h4({ class: "text-secondary fw-bold mb-0" }, `${ctx?.mpesaInfo?.charges || "0.00"}`)
                        )
                    )
                )
            ),

            // Highlighted instruction banner
            h.div(
                {
                    class: "alert alert-warning border-0 border-start border-warning border-4 shadow-sm rounded-4 p-4 mb-4 d-flex align-items-start gap-3",
                    style: "background-color: #fff9e6; color: #664d03;"
                },
                h.i({ class: "bi bi-exclamation-triangle-fill text-warning fs-4 mt-1" }),
                h.div(
                    h.h6({ class: "fw-bold mb-1", style: "color: #664d03;" }, "Already made this payment?"),
                    h.p(
                        { class: "small mb-0 fw-500 text-secondary", style: "line-height: 1.5;" },
                        "If you have already paid, please go back and enter the transaction ID instead of your phone number in the payment form."
                    )
                )
            ),

            h.div(
                { class: "d-flex justify-content-between align-items-center" },
                h.BackButton(),
                h.button(
                    {
                        class: "btn btn-success rounded-pill px-4 py-2 fw-bold shadow-sm",
                        onclick: this.method("checkPayment"),
                    },
                    "Finish"
                )
            )
        );
    }

    checkPayment() {
        inform("Checking your payment");
    }
}
